import React, { useState } from "react";

export const Search = (props) => {
    const { handleClick, placeholder, items, id } = props;

    const [searchQuery, setSearchQuery] = useState();
    const [isActive, setIsActive] = useState(false);
    const [filteredItems, setFilteredItems] = useState(items);

    return (
        <div>
            <label htmlFor={id} className="sr-only">
                {" "}
                Search{" "}
            </label>
            <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <svg
                        className="w-5 h-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        ></path>
                    </svg>
                </div>

                <input
                    type="search"
                    name="search-input"
                    value={searchQuery}
                    onChange={(e) => {
                        // Filter items in live
                        const defineActive = e.target.value.length
                            ? true
                            : false;
                        setIsActive(defineActive);
                        setSearchQuery(e.target.value);
                        const res = items.filter((item) => {
                            return item.label
                                .normalize("NFD")
                                .replace(/[\u0300-\u036f]/g, "")
                                .toLowerCase()
                                .includes(
                                    e.target.value
                                        .normalize("NFD")
                                        .replace(/[\u0300-\u036f]/g, "")
                                        .toLowerCase()
                                );
                        });
                        setFilteredItems(res);
                    }}
                    id={id}
                    className="block w-full py-2 pl-10 border border-gray-300 rounded-lg focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm"
                    placeholder={placeholder}
                />
            </div>
            {isActive && filteredItems.length !== 0 && (
                <div className="absolute flex flex-col text-gray-700 bg-white shadow-md w-52 rounded-xl bg-clip-border">
                    <nav className="flex flex-col gap-1 p-2 font-sans text-base font-normal text-blue-gray-700">
                        {filteredItems.map((item, index) => (
                            <div
                                role="button"
                                key={index}
                                className="py-1 flex items-center p-3 leading-tight transition-all rounded-lg outline-hidden text-start hover:bg-blue-gray-50/80 hover:text-blue-gray-900 focus:bg-blue-gray-50/80 focus:text-blue-gray-900 active:bg-blue-gray-50/80 active:text-blue-gray-900"
                                onClick={() => {
                                    handleClick(item);
                                    setIsActive(false);
                                    setSearchQuery("");
                                }}
                            >
                                {item.label}
                            </div>
                        ))}
                    </nav>
                </div>
            )}
        </div>
    );
};
